import type { LinkBoxType } from './types';
import { LinkByText } from '../LinkByText/LinkByText';

export const LinkBoxCaption = ({ data, link }: { data: LinkBoxType; link: string }) => {
  const { field_button_text: buttonText, behavior_paragraph_cta_icon: buttonIcon } = data;
  return (
    buttonText && (
      <LinkByText
        noUnderline
        data={{
          ...data,
          type: 'link_by_text',
          field_link: link,
          field_text: buttonText,
          field_icon: buttonIcon ? 'ArrowRight' : undefined,
        }}
        className={
          // svg stuff is needed to vertically align the text to the optional icon
          'mt-[0.125rem] w-full font-semibold [&&]:[&_svg]:relative! [&&]:[&_svg]:mt-[-0.05rem]!'
        }
      />
    )
  );
};
